// Angular core
import { ApplicationConfig, inject, InjectionToken, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// NgRx
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';

// Environment
import { environment } from '../environments/environment';

// Interceptors
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { httpTimingInterceptor } from './core/interceptors/http-timing.interceptor';

// PrimeNG
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

// App routes
import { routes } from './app.routes';

// Auth
import { AuthService } from './core/auth/services/auth.service';
import { API_BASE_URL } from '@core/tokens/api-base';

// UI Store
import { uiReducer } from './application/store/ui/ui.reducer';
import { UiEffects } from './application/store/ui/ui.effects';


function initializeApp1(authService: AuthService) {
  return authService.initSession();
}

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular Core
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, httpTimingInterceptor])),
    provideAnimationsAsync(),

    //store vacio
    provideStore({ ui: uiReducer }),

    // Herramientas de dev globales
    provideStoreDevtools({ maxAge: 25, logOnly: !environment.production }),

    // Injection tokens globales
    // Provided here and not in a feature config: the repositories that consume it are
    // `providedIn: 'root'`, and the root injector cannot resolve route-level providers.
    { provide: API_BASE_URL, useValue: environment.apiEndpoints.gatewayBaseUrl },

    // PrimeNG Config global
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme',
          cssLayer: false,
        },
      },
    }),

    // PrimeNG Services (uso transversal en toda la app)
    ConfirmationService,
    MessageService,
    provideAppInitializer(() => initializeApp1(inject(AuthService))),

    // Effects
    provideEffects([UiEffects]),
  ],
};
